import { memo } from "react";
import { RouterProvider } from "react-router";
import { routes } from "router/routes";

export const AppRoutes = memo(() => {
  return <RouterProvider router={routes} />;
});
